export default __webpack_public_path__ + "static/media/top-ten-7.d67d4725.svg";